<!--
<br />
<mat-slide-toggle *ngIf="false" [(ngModel)]="appService.isNavigationPinned">
    <span>Pin Menu</span>
</mat-slide-toggle>
<br />
<br />
-->
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" [ngClass]="{'horizontal-tree': appService.screenSize === 1 && !appService.isRootNodesCountAboveFooterCapacity}">
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <span (click)="appService.navigateTo(node.route, node.venueRootSubdomain)" class="node-label">
            <span class="tree-node-wrapper">
                <span class="node-label">
                    <span class="tree-node-icon-container" style="color:{{node.color}}; margin-left: 6px;">
                        <ng-container *ngIf="node.iconOverrideImagePath && node.iconOverrideImagePath !== ''; else defaultIcon">
                            <img [src]="node.iconOverrideImagePath" class="node-icon-img" alt="icon" />
                        </ng-container>
                        <ng-template #defaultIcon>
                            <mat-icon class="material-symbols-outlined">{{node.maticon}}</mat-icon>
                        </ng-template>
                    </span>
                    <br />
                    <span class="nav-label" style="font-weight: normal; padding-left: 4px;">
                        {{ appService.screenSize == 1 ? (node.shortName != "" ? node.shortName : node.name) : node.name }}
                    </span>
                </span>
                <span *ngIf="isAdministrator" class="material-symbols-outlined cloaked-button" [matMenuTriggerFor]="menu">more_vert</span>
            </span>
        </span>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editNode(node)">
                <mat-icon class="material-symbols-outlined button-icon">edit</mat-icon>
                <span>Edit Node</span>
            </button>
            <button mat-menu-item (click)="addNode(node)">
                <mat-icon class="material-symbols-outlined button-icon">add</mat-icon>
                <span>Add new node beneath</span>
            </button>
            <button mat-menu-item (click)="addNode(null)">
                <mat-icon class="material-symbols-outlined button-icon">add</mat-icon>
                <span>Add new node at root</span>
            </button>
        </mat-menu>
        <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
    </mat-tree-node>
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <span (click)="appService.navigateTo(node.route, node.venueRootSubdomain)" class="node-label">
            <span class="tree-node-wrapper">
                <span class="tree-node-icon-container" style="color:{{node.color}};margin-left:6px;vertical-align:middle;">
                    <ng-container *ngIf="node.iconOverrideImagePath && node.iconOverrideImagePath !== ''; else defaultIconFlat">
                        <img [src]="node.iconOverrideImagePath" class="node-icon-img" alt="icon" />
                    </ng-container>
                    <ng-template #defaultIconFlat>
                        <mat-icon class="material-symbols-outlined">{{node.maticon}}</mat-icon>
                    </ng-template>
                </span>
                <br />
                <span class="nav-label" style="font-weight: normal;padding-left: 4px; vertical-align: middle ">
                    {{ appService.screenSize == 1 ? (node.shortName != "" ? node.shortName : node.name) : node.name }}
                </span>
            </span>
            <span *ngIf="isAdministrator" class="material-symbols-outlined cloaked-button" [matMenuTriggerFor]="menu">more_vert</span>
        </span>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editNode(node)">
                <mat-icon class="material-symbols-outlined button-icon">edit</mat-icon>
                <span>Edit Node</span>
            </button>
            <button mat-menu-item (click)="addNode(node)">
                <mat-icon class="material-symbols-outlined button-icon">add</mat-icon>
                <span>Add new node beneath</span>
            </button>
        </mat-menu>
    </mat-tree-node>
</mat-tree>
